import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { FiSlash, FiUserX, FiUserCheck } from 'react-icons/fi';
import { cBlockUser, cUnblockUser } from '../../api';
import { useCommunity } from '../../contexts/CommunityContext';
import { useLanguage } from '../../i18n';

/**
 * **Block / unblock** a member (“គណនីដែលត្រូវបានប្លុក”).
 *
 * Blocking hides the two accounts from each other everywhere — articles,
 * comments, stories, the people directory and the direct chat — and removes the
 * follows between them. The blocked accounts are listed on `/blocked`.
 */
export default function BlockButton({ user: target, blocked = false, onChanged, compact = false }) {
  const { t } = useLanguage();
  const { user, requireAuth } = useCommunity();
  const [busy, setBusy] = useState(false);
  if (!target || (user && user.id === target.id)) return null;

  const toggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!requireAuth(t('loginRequiredDesc'))) return;
    const question = (blocked ? t('unblockConfirm') : t('blockConfirm'))
      .replace('{u}', target.username || '');
    if (!window.confirm(question)) return;
    setBusy(true);
    try {
      if (blocked) {
        await cUnblockUser(target.id);
        toast.success(t('unblockedOk'));
      } else {
        await cBlockUser(target.id);
        toast.success(t('blockedOk'));
      }
      if (onChanged) onChanged(!blocked);
    } catch (err) {
      toast.error(err?.response?.data?.detail || t('somethingWrong'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      disabled={busy}
      onClick={toggle}
      className={`inline-flex items-center gap-1.5 rounded-full font-bold transition disabled:opacity-50 ${
        compact ? 'px-3 py-1.5 text-xs' : 'px-4 py-2 text-sm'
      } ${
        blocked
          ? 'text-white'
          : 'text-gray-600 dark:text-gray-300 border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800'
      }`}
      style={blocked ? { background: '#dc2626' } : undefined}
    >
      {blocked ? <FiUserCheck className="w-4 h-4" /> : <FiUserX className="w-4 h-4" />}
      {blocked ? t('unblockUser') : t('blockUser')}
      {!compact && !blocked && <FiSlash className="w-3 h-3 opacity-50" />}
    </button>
  );
}